<script>
    import { updateProvider, deleteProvider } from '@/api/providers.js';
    import constants from '@/constants';

    export default {
        computed: {
            saveButton() {return this.$store.getters.IS_SAVE_PAG_PROVIDER_EDIT}
        },
        methods: {
            async save() {
                const response = await updateProvider(
                    this.$store.getters.PAG_PROVIDER_EDIT
                );
                if (response === true) {
                    const data = this.$store.getters.PAG_PROVIDER_EDIT;
                    this.$store.commit('PAG_PROVIDER_UPDATE', {id: data.id, payload: data});
                    this.$store.commit('PROVIDER_UPDATE', {id: data.id, payload: data});
                    await this.close();
                }
            },

            async showDeletePopup() {
                this.$store.commit('SHOP_POPUP_NAME', constants.POPUPS_NAME.CONFIRMED);
                this.$store.commit('CONFIRMED_POPUP_METHOD', this.deleteObj.bind(this));
            },
            
            async deleteObj() {
                const providerID = this.$store.getters.PAG_PROVIDER_EDIT.id;
                const response = await deleteProvider(providerID);
                if (response === true) {
                    this.$store.commit('PAG_PROVIDER_SPLIT', providerID);
                    this.$store.commit('PROVIDER_SPLIT', providerID)
                    await this.close();
                }
            },
            async close() {
                this.$store.commit('IS_SHOW_PAG_RROVIDER_EDIT', false);
            }
        }
    }
</script>


<template>
    <div>
        <button
            :disabled="saveButton === false"
            class="button_blue_100"
            @click="save"
        >Save</button>
        <button
            class="button_blue_100 button_red ml_10"
            @click="showDeletePopup"
        >Delete</button>
        <button
            class="button_blue_100 close_button mr_10"
            @click="close"
        >Close</button>
    </div>
</template>